import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { CollapseModule } from 'ngx-bootstrap/collapse'
import { RouterModule } from '@angular/router'

import { NavBarComponent } from './nav-bar.component'
import { SessionActions } from 'src/actions/session-actions'
import { ScheduleEventModal } from '../../components/modals/schedule-event-modal.component'
import { ModalModule } from '../modal/modal.module'
import { HomeLink } from './home-link.component'
import { AlertBanner } from '../../components/alert-banner.component'


@NgModule({
  imports: [
    CommonModule,
    BsDropdownModule,
    CollapseModule.forRoot(),
    RouterModule,
    ModalModule
  ],
  declarations: [
    NavBarComponent,
    ScheduleEventModal,
    HomeLink,
    AlertBanner
  ],
  providers: [
    SessionActions,
    AlertBanner
  ],
  exports: [
    NavBarComponent,
    HomeLink
  ]
})
export class NavBarModule {}
